<div class="form-group">
  <label
    [ngClass]="{ 'question-text-customer': to.className === 'xilo-input' }"
  >
    {{ to.label }}
    <span *ngIf="to.required">*</span>
  </label>
</div>
<div class="file-upload-buttons">
  <div class="add-files">
    <label [for]="inputId" class="file-upload-label">
      <fa-icon [icon]="icons.cloud" class="upload-icon"></fa-icon>
      {{ files.length > 0 ? 'Add Another' : 'Choose' }} File
    </label>
    <input
      [id]="inputId"
      class="file-upload-input"
      type="file"
      multiple
      (change)="filesSelected($event)"
    />
  </div>
  <div class="upload-files">
    <button
      class="upload-button"
      *ngIf="files.length > 0"
      (click)="uploadFiles()"
    >
      Done Adding Files
    </button>
  </div>
</div>
<div class="files">
  <div
    *ngFor="let file of files; index as i; first as isFirst"
    class="file"
    [ngClass]="{ first: isFirst }"
  >
    {{ file.file.name }}
    <div class="icons">
      <fa-icon
        *ngIf="file.status === 'uploading'"
        [icon]="icons.uploading"
        [spin]="true"
      ></fa-icon>
      <fa-icon
        *ngIf="file.status === 'success'"
        [icon]="icons.success"
        class="success"
      ></fa-icon>
      <fa-icon
        *ngIf="file.status === 'error'"
        [icon]="icons.error"
        class="error"
      ></fa-icon>
      <fa-icon
        *ngIf="file.status === 'ready' || file.status === 'error'"
        class="remove-file-button"
        [icon]="icons.remove"
        (click)="removeFile(i)"
      ></fa-icon>
    </div>
  </div>
</div>
